import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import UserProfile from "./User";
import { getToken } from "../utils/token";
import api from "../utils/webcall";


function AccessController(props) {
    const { restricted, onlyAdmin, children } = props;
    const navigate = useNavigate();

    const checkSession = useCallback(async () => {
        try {
            const isValid = await UserProfile.verifySession();
            if (!isValid) {
                UserProfile.logout();
                navigate("/");
            }
        } catch (error) {
            console.error('Session check error:', error);
            UserProfile.logout();
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        if (restricted) {
            if (!UserProfile.isLoggedIn()) {
                navigate("/");
                return;
            }
            // Initial session check
            checkSession();
            
            // Set up periodic session checks (every 5 minutes)
            const sessionCheckInterval = setInterval(checkSession, 5 * 60 * 1000);
            
            return () => {
                clearInterval(sessionCheckInterval);
            };
        }
        
        if (onlyAdmin && !UserProfile.isManager()) {
            navigate("/");
        }
    }, [restricted, onlyAdmin, navigate, checkSession])


    return (
        <>
            {children}
        </>
    )
}



AccessController.defaultProps = {
    restricted: true,
    onlyAdmin: true
};

export default AccessController;